export function parseToken(token) {
  if (!token) {
    return null;
  }
  return JSON.parse(decodeURIComponent(atob(token.split('.')[1])));
}
